import {
  Building2,
  Dumbbell,
  Wrench,
  TicketPercent,
  MessageSquare,
  Plug,
  ShieldCheck,
  Cog,
  type LucideProps,
} from 'lucide-solid';
import type { Component } from 'solid-js';
import { SETTINGS_NODES, type SettingsNode } from '~/shared/api/settings-api';

export type SettingsModuleKey = SettingsNode['module'];

export interface SettingsModule {
  key: SettingsModuleKey;
  label: string;
  sub: string;
  route: string;
  icon: Component<LucideProps>;
  accent: string;
  tint: string;
  standalone?: { soft: string; hairline: string };
}

export const SETTINGS_MODULES: SettingsModule[] = [
  { key: 'club', label: 'Клуб', sub: 'Профиль, расписание, нумерация, бренд',
    route: '/settings/club', icon: Building2, accent: '#9CA3AF', tint: 'rgba(156,163,175,0.16)' },
  { key: 'operations', label: 'Операции', sub: 'Каталог, корты, бронирование, шахматка',
    route: '/settings/operations', icon: Wrench, accent: '#087DE4', tint: 'rgba(8,125,228,0.16)' },
  { key: 'pricing-loyalty', label: 'Цены и лояльность', sub: 'Категории, бонусы, абонементы, налоги',
    route: '/settings/pricing-loyalty', icon: TicketPercent, accent: '#6AD10F', tint: 'rgba(106,209,15,0.16)' },
  { key: 'communications', label: 'Коммуникации', sub: 'Новости, шаблоны, напоминания, DND',
    route: '/settings/communications', icon: MessageSquare, accent: '#ACD317', tint: 'rgba(172,211,23,0.16)' },
  { key: 'integrations', label: 'Интеграции', sub: 'СКУД, ККМ, эквайринг, мессенджеры',
    route: '/settings/integrations', icon: Plug, accent: '#FFD12B', tint: 'rgba(255,209,43,0.16)' },
  { key: 'access-security', label: 'Доступ и безопасность', sub: 'Роли, зоны, устройства, аудит',
    route: '/settings/access-security', icon: ShieldCheck, accent: '#FF8C42', tint: 'rgba(255,140,66,0.16)' },
  { key: 'system', label: 'Система', sub: 'Бэкапы, импорт/экспорт, о системе',
    route: '/settings/system', icon: Cog, accent: '#6B7280', tint: 'rgba(107,114,128,0.16)' },
  { key: 'fitness', label: 'Фитнес', sub: 'Раздел, состав, посещения, заморозка, тарифы',
    route: '/settings/fitness', icon: Dumbbell, accent: 'var(--fitness)', tint: 'var(--fitness-soft)',
    standalone: { soft: 'var(--fitness-soft)', hairline: 'var(--fitness-hairline)' } },
];

const nodeHref = (id: string): string => {
  const node = SETTINGS_NODES.find((n) => n.id === id);
  if (!node) throw new Error(`Узла настроек «${id}» нет в SETTINGS_NODES`);
  return node.href;
};

export const FITNESS_TARIFFS_HREF = nodeHref('fitness-tariffs');

export const SUBSCRIPTION_TARIFFS_HREF = '/loyalty?tab=subscriptions&view=templates';
export const PROMOCODES_HREF = '/loyalty?tab=promocodes';

export const CARD_CATEGORIES_HREF = nodeHref('pl-categories');

export const FITNESS_GENERAL_HREF = nodeHref('fitness-general');

export const ACCESS_ZONES_HREF = nodeHref('as-zones');

export const nodesForModule = (key: SettingsModuleKey): SettingsNode[] =>
  SETTINGS_NODES.filter((n) => n.module === key);
